import { ChildRef } from '../../../../../lib/web/components/child-ref';
import { ClickListener } from '../../../../../lib/web/components/click-listener';
import { Component } from '../../../../../lib/web/components/component';
import { ComponentBase } from '../../../../../lib/web/components/component-base';
import { ApiService } from '../../../services/api.service';
import { ToggleSelectorComponent } from '../../atoms/toggle-selector/toggle-selector.component';
import { DisciplinesSelectorComponent } from '../../molecules/disciplines-selector/disciplines-selector.component';

@Component({
    selector: '.p-first-access'
})
export class FirstAccessComponent extends ComponentBase<HTMLElement> {

    @ChildRef()
    private _disciplinesSelector: DisciplinesSelectorComponent = null;

    public constructor(node: HTMLElement, private _apiService: ApiService) {
        super(node);
    }

    public onInit(): void {
        super.onInit();
        this._disciplinesSelector.focus();
    }   

    @ClickListener('.p-first-access__start')
    public async onStart(): Promise<void> {
        const selected: number[] = this._disciplinesSelector.selection;
        if (selected && selected.length) {
            // Evita que un doble clic lance varias peticiones mientras la primera está en curso
            this.disable('.p-first-access__start');
            try {
                await this._apiService.post('/api/v1/user/disciplines', {
                    body: {
                    disciplines: selected
                    }
                });
            }
            catch (e: any) {
                logger.warn(e);
                // Las disciplinas son una preferencia opcional: un fallo no debe impedir acceder a la plataforma
            }
            finally {
                this.enable('.p-first-access__start');
            }
        }
        this.redirect('/');
    }
}